<template lang="pug">
  .quotes
    h2 Welcome, {{ !$root.currentUser.guest && $root.currentUser.name ? abbrName($root.currentUser.name).fname : ''}}!
    .quote-list
      .drafts
        h4 My Drafts 
          span(v-if="drafts.length > 0") {{'(' + drafts.length + ')'}}
          a(v-if="!$root.currentUser.guest" @click="newDraft($root.currentUser.uid)")
            svg.new.right(xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" focusable="false" x="0px" y="0px" viewBox="0 0 448 512" style="enable-background:new 0 0 448 512;" xml:space="preserve")
              g
                path(d="M224,32.5C100.6,32.5,0.5,132.6,0.5,256S100.6,479.5,224,479.5S447.5,379.4,447.5,256S347.4,32.5,224,32.5z    M318.1,264.2h-85v85c0,5.5-4.5,10-10,10s-10-4.5-10-10v-85h-83.2c-5.5,0-10-4.5-10-10s4.5-10,10-10h83.2v-81.4c0-5.5,4.5-10,10-10   s10,4.5,10,10v81.4h85c5.5,0,10,4.5,10,10S323.6,264.2,318.1,264.2z")
            | Start New
        .flex-row.header(v-if="drafts.length > 0")
          .quote-main
            p.date Date
            p.number Draft #
            p.status
            p
        .flex-row(v-if="drafts.length > 0" v-for='draft in drafts')
          .quote-main
            p.date {{ formatDate(draft.lastUpdated) }}
            p.number.clickable(:id="draft.id" @click="getDraft(draft)") {{ draft.id }}
            p.status
            p.dropdown(v-if="draft.items.length > 0" @click="showDetails($event)")
              svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414")
                path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
            p.dropdown(v-else)
          .quote-details.hide
            .product(v-for='item in draft.items')
              .description
                a(:href="item.product.link" target="_blank")
                  h5.product-title {{ item.product.title }}
                p.product-variations(v-if="item.notes") {{ stringReplace(item.notes) }}
              p.quantity {{ item.quantity }}
        .no-quotes(v-if="drafts.length == 0")
          p You do not currently have any drafts.
          p Click 
            a(@click="newDraft($root.currentUser.uid)") Start New
            |  or add a product to get started!
      
      .quotes(v-if="otherQuotes.length > 0")
        h4 My Quotes 
          span(v-if="otherQuotes.length > 0") {{'(' + otherQuotes.length + ')'}}
        .flex-row.header
          .quote-main
            p.date Date
            p.number Quote #
            p.status Amount
            p.dropdown
        .flex-row(v-for="quote in otherQuotes" :key="quote.id")
          .quote-main
            p.date {{ formatDate(quote.lastUpdated) }}
            p.number.clickable(:id="quote.id" @click="viewQuote(quote)") {{ quote.id }}
            p.status.italic(v-if="quote.state == 'requested'")
              span.tag Requested
            p.status.italic(v-else) {{formatPrice(quote.total)}}
              span(v-if="quote.state == 'accepted'")
                svg(xmlns="http://www.w3.org/2000/svg" width="37.31" height="37.329" viewBox="0 0 37.31 37.329")
                  g(stroke-width="3")
                    ellipse(cx="18.655" cy="18.664" rx="18.655" ry="18.664" stroke="none")
                    ellipse(cx="18.655" cy="18.664" rx="17.155" ry="17.164" fill="none")
                  path(d="M3624.407,337.244l4.4,4.4,8-8.288" transform="translate(-3610.9 -318.419)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
            p.dropdown(@click="showDetails($event)")
              svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414")
                path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .quote-details.hide
            .product(v-for='item in quote.items')
              .description
                a(:href="item.product.link" target="_blank")
                  h5.product-title {{ item.product.title }}
                p.product-variations(v-if="item.notes") {{ stringReplace(item.notes) }}
              p.quantity {{ item.quantity }}

</template>

<script>
import Account from "../scripts/accounts.js";
import { Quotes } from "../scripts/quotes.js";
import Activity from "../scripts/activity.js";

function createId(str) {
  var sum = 0;
  for (let i = 0; i < str.length; i++) {
    sum += str.charCodeAt(i);
  }
  return sum;
}

export default {
  name: "Quotes",
  data() {
    return {
      quotes: [],
      userData: null
    };
  },
  computed: {
    drafts: function() {
      return this.quotes.filter(quote => quote.state === "draft");
    },
    otherQuotes: function() {
      var requestedQuotes = this.quotes.filter(
        quote => quote.state != "draft" && quote.state != "closed"
      );

      return requestedQuotes
        .sort((a, b) => (a.lastUpdated > b.lastUpdated ? 1 : -1))
        .reverse();
    }
  },
  watch: {
    drafts(newDrafts) {
      var recent = newDrafts
        .sort((a, b) => (a.startedAt > b.startedAt ? 1 : -1))
        .reverse();
      var recentQuote = recent[0];
      this.$root.activeDraft = recentQuote;
      var draftStr = JSON.stringify(recentQuote);
      if (draftStr) {
        sessionStorage.setItem("draft_quotes", draftStr);
      }
    }
  },
  methods: {
    formatPrice(value) {
      if (value) {
        return (
          "$" +
          parseFloat(value)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
        );
      } else {
        return "0.00";
      }
    },
    formatDate(date) {
      // Check for valid date
      if (isNaN(Date.parse(date)) === false) {
        var formatDate = new Date(date);
      } else if (typeof date === "number") {
        if (date.toString().length === 10) {
          var formatDate = new Date(date * 1000);
        } else {
          var formatDate = new Date(date);
        }
      } else {
        return date;
      }

      let formatMonth = ("0" + formatDate.getMonth()).slice(-2);
      let formatDay = ("0" + formatDate.getDate()).slice(-2);
      let formatYear = formatDate
        .getFullYear()
        .toString()
        .substr(-2);

      return `${formatMonth}/${formatDay}/${formatYear}`;
    },
    showDetails(e) {
      if (e) {
        var target = e.target || e.srcElement;
        var details;
        if (target.nodeName == "svg") {
          details = target.parentNode.parentNode.nextSibling;
        } else if (target.nodeName == "path") {
          target = target.parentNode;
          details = target.parentNode.parentNode.nextSibling;
        }
        //Show or hide details
        if (details) {
          if (details.classList.contains("hide")) {
            details.classList.remove("hide");
            details.parentNode.classList.add("active");
          } else {
            details.classList.add("hide");
            details.parentNode.classList.remove("active");
          }
        }
        if (target) {
          //flip arrow
          if (target.classList.contains("up")) {
            target.classList.remove("up");
          } else {
            target.classList.add("up");
          }
        }
      }
    },
    stringReplace(notes) {
      var str = notes.replace(/;\n/g, " / ");
      str = str.replace(";", "");
      return str;
    },
    getDraft(draft) {
      this.$root.activeDraft = draft;
      this.$root.currentState = "draft";
    },
    newDraft(userId = "guest") {
      let date = new Date();
      let u_part =
        createId(userId.substring(userId.length - 5)) +
        date.getFullYear() +
        date.getMonth();
      let ms = date.getMilliseconds() + Math.random() * 1000000;
      let t_part = `${(date.getFullYear() + date.getMonth() + ms).toString(
        16
      )}`.substr(0, 4);
      let quoteId = `MLQ-${u_part.toString(16)}-${t_part}`;
      var self = this;
      Quotes.newQuote(quoteId, userId, this.userData).then(results => {
        this.$root.activeDraft = results;
        this.$root.currentPage = "Quotes";
        this.$root.currentState = "draft";

        Activity.userActivity(this.$root.currentUser, "request:new", {
          quote: results
        });
      });
    },
    viewQuote(quote) {
      this.$root.activeQuote = quote;
      this.$root.currentState = "viewQuote";
    },
    abbrName: function(name) {
      if (name) {
        var parts = name.split(" ");
        if (parts.length > 1) {
          return { fname: parts[0], lname: parts[1] };
        } else {
          return { fname: parts[0], lname: "" };
        }
      } else {
        return null;
      }
    }
  },
  mounted: function() {
    this.$root.currentPage = "Quotes";
    Quotes.getQuotes(this.$root.currentUser.uid).then(results => {
      if (results.size > 0) {
        results.forEach(doc => {
          let data = doc.data();
          this.quotes.push(data);
        });
      }
    });

    if (this.$root.currentUser.uid) {
      Account.getAccount(this.$root.currentUser.uid).then(results => {
        this.userData = results;
      });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/reset.scss";
@import "../assets/styles/variables.scss";
#app .quotes {
  h2 {
    padding: 24px;
  }
  .italic {
    font-style: italic;
  }
  .quote-list {
    .drafts,
    .quotes {
      .no-quotes {
        p {
          padding: 0.5em 1.3em;
        }
      }
      h4 {
        padding: 24px;
        background-color: $primary_color;
        color: #fff;
        span {
          font-size: 0.875em;
        }
        a {
          float: right;
          font-size: 14px;
          color: #fff !important;
          svg.new {
            fill: #fff;
            height: 17px;
            vertical-align: sub;
            margin-right: 7px;
            width: 15px;
            path {
              stroke: #fff;
            }
          }
        }
        a:hover {
          font-weight: 500;
        }
      }
      .flex-row {
        border-bottom: 1.5px solid $border_gray;
        &.active {
          border-bottom: 2px solid $primary_color;
        }
        &.header {
          border-bottom: 2px solid $primary_color;
          background-color: #cbcbcb;
          font-size: 1em;
        }
        .quote-main {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          font-size: 15px;
          padding: 1em 24px;
          width: 100%;
          .date,
          .number,
          .status {
            font-size: 0.9em;
          }
          p.date {
            width: 25%;
          }
          p.number {
            width: 35%;
          }
          p.status {
            width: 30%;
          }
          p.dropdown {
            text-align: right;
            width: 5%;
            svg {
              height: 10px;
              width: 17px;
            }
            svg.up {
              transform: rotate(180deg);
            }
            svg path {
              stroke: $link_color;

              &:hover {
                cursor: pointer;
                stroke: $link_hover;
              }
            }
          }
          p.clickable {
            font-weight: 500;
            color: $link_color;
            text-decoration: underline;
          }
          p.clickable:hover {
            color: $link_hover;
            cursor: pointer;
            color: $link_hover;
          }
          span svg {
            fill: $alert_green;
            width: 15px;
            height: 15px;
            vertical-align: top;
            margin-left: 5px;
          }
          .tag {
            background-color: $alert_green;
            padding: 2px 7px 2px 3px;
            color: #fff;
            font-weight: 100;
          }
        }

        .quote-details {
          width: 100%;
          background-color: $drop_down_color;
          font-size: 0.875em;
          transition: all 0.5s ease-in-out;
          &.hide {
            display: none;
          }
          .product:not(:last-of-type) {
            border-bottom: 1.5px solid $border_gray;
          }
          .product {
            display: flex;
            flex-wrap: wrap;
            padding: 1em 24px;

            .description {
              width: 80%;
              h5 {
                font-weight: 500;
                color: $link_color;
                margin-bottom: 5px;
              }
              h5:hover {
                color: $link_hover;
              }
              .product-variations {
                line-height: 1.25;
              }
            }
            .quantity {
              width: 20%;
              text-align: right;
              color: $text_color;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}
</style>
